(function () {
  'use strict';
  angular.module('vcdms.vcscan')
    .component('scancounter', {
      restrict: 'E',
      bindings: {},
      template: `
        <span class="badge badge-warning" data-hook="scancounter" ng-bind="vm.counter"  uib-tooltip="Neue Scans zu sortieren"  tooltip-placement="auto"></span>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'File', 'Rlog', 'vertxEventBusService', '$http',
        function ($log, File, Rlog, vertxEventBusService, $http) {
          let vm = this;

          const getCounter = function () {
            let query = [{
              $match: {
                scanstatus: 'captured',
                active: true
              }
            }, {
              $group: {
                _id: null,
                counter: {$sum: 1}
              }
            }];

            $http.post('/routes/files/aggregate', query).then(res => {
              vm.counter = 0;
              if (res.data.counter) {
                vm.counter = res.data.counter;
              }
            }, err => {
              $log.error('scancounter.$aggregate failed: ', err);
              Rlog.error('dms.scan', 'scancounter', 'scancounter.$aggregate failed', {});
            });
          };

          vm.$onInit = function () {
            getCounter();

            // listen for files updates
            vertxEventBusService.on('scanfile.update', {}, getCounter);
            vertxEventBusService.on('files.update', {}, getCounter);
            vertxEventBusService.on('files.create', {}, getCounter);
          }; // $onInit()



          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('files.update', {}, getCounter);
            vertxEventBusService.unregisterHandler('scanfile.update', {}, getCounter);
            vertxEventBusService.unregisterHandler('files.create', {}, getCounter);
          };

        }
      ] // controller
    }); // component

// klammerfriedhof
}());
